var h = (b, U, n) => new Promise((d, r) => {
  var p = (s) => {
    try {
      u(n.next(s));
    } catch (f) {
      r(f);
    }
  }, i = (s) => {
    try {
      u(n.throw(s));
    } catch (f) {
      r(f);
    }
  }, u = (s) => s.done ? d(s.value) : Promise.resolve(s.value).then(p, i);
  u((n = n.apply(b, U)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { OssUpload as O } from "@oppein-lib/op-upload";
import { getOnlinePreviewUrl as V, getOssUrl as z } from "@oppein/op-utils";
import T from "./util/baseUrl.js";
import K from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/upload/src/Upload.js";
import { defineComponent as j, inject as w, watch as q, onMounted as H, openBlock as S, createElementBlock as W, createElementVNode as R, createVNode as $, Fragment as G } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as J } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as y, unref as Q } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const se = /* @__PURE__ */ j({
  __name: "fileUpload",
  props: {
    businessType: { default: "Public" },
    value: { default: () => [] },
    maxLength: {},
    src: { default: "ossKey" }
  },
  emits: ["update:value"],
  setup(b, { emit: U }) {
    const n = w("shadowRoot"), d = w("appCode"), r = w("subAppCode"), p = w("oauth2AccessToken"), i = w("env"), u = (d == null ? void 0 : d.value) || "", s = (r == null ? void 0 : r.value) || "", f = (p == null ? void 0 : p.value) || "", _ = i != null && i.value && ["sit", "uat", "ver", "pro"].includes(i.value) ? i.value : "pro";
    console.log(r, "subAppCode");
    const m = b, k = U, C = J(), a = y([...m.value]), E = y(!1), L = y(""), x = y(null);
    function M(e) {
      a.value.forEach((t) => {
        var o;
        t.id === e.id && window.open(
          V(
            z({
              url: (o = t.url) != null ? o : void 0
            })
          ),
          "_blank"
        );
      }), console.log("previewImageUrlRef", L.value), console.log("file", e), E.value = !0;
    }
    const P = (e) => {
      const { file: t } = e;
      if (!a.value.find((c) => c.id === t.id))
        return;
      const g = a.value.filter((c) => c.id !== t.id);
      D(g);
    }, A = (e) => h(this, null, function* () {
      const t = a.value.find((o) => o.id === e.id);
      if (!t || !t.url) {
        C.error("文件下载地址不存在");
        return;
      }
      try {
        const o = document.createElement("a");
        o.href = t.url, o.download = t.name || `下载文件_${Date.now()}`, n && n instanceof HTMLElement ? n.appendChild(o) : document.body.appendChild(o), o.click(), setTimeout(() => {
          o.remove();
        }, 100);
      } catch (o) {
        console.error("文件下载失败:", o);
      }
    }), B = (e) => h(this, null, function* () {
      var t, o, g, c;
      try {
        const v = yield I(e.file);
        if (!v || v.status === void 0)
          return e.onError(new Error("上传结果无效"), e), null;
        const l = v;
        let F = {
          id: ((t = l.file) == null ? void 0 : t.id) || "",
          name: l.filename,
          suffix: l.suffix,
          ossKey: l.name,
          path: l.name,
          uid: (o = l.file) == null ? void 0 : o.id,
          size: l.size,
          file: e,
          url: l.url || l.name,
          filename: l.filename,
          fullPath: l.url,
          isDelete: !0,
          isDownload: !0,
          status: "finished",
          lastModified: ((c = (g = e == null ? void 0 : e.file) == null ? void 0 : g.file) == null ? void 0 : c.lastModified) || (/* @__PURE__ */ new Date()).getTime()
        };
        return console.log("file", e), e.onFinish(), a.value = [...a.value, F], console.log("localFileList.value", a.value), D(a.value), F;
      } catch (v) {
        return console.error(v), null;
      }
    }), N = () => {
      T.init(_);
      const e = T.getBaseUrl().apigateway;
      x.value = new O({
        appCode: u || "",
        subAppCode: s || "",
        baseURL: e,
        token: f || ""
      });
    }, I = (e) => h(this, null, function* () {
      var o;
      if (!m.businessType)
        throw new Error("上传文件必须定义businessType");
      console.log("file", e);
      let t = yield (o = x.value) == null ? void 0 : o.uploadFile(
        e,
        {
          sysPlatform: u || "",
          businessType: m.businessType
        },
        0
      );
      return console.log("resData", t), t;
    }), D = (e) => {
      a.value = e, console.log("组件触发update:fileList", e), k("update:value", e);
    };
    return q(
      () => m.value,
      (e) => {
        a.value = [...e];
      },
      { deep: !0 }
    ), H(() => {
      N();
    }), (e, t) => (S(), W(G, null, [
      R("div", {
        ref_key: "shadowRootRef",
        ref: n
      }, null, 512),
      R("div", null, [
        R("div", null, [
          $(Q(K), {
            action: "",
            "default-file-list": a.value,
            "custom-request": B,
            "list-type": "image-card",
            max: m.maxLength,
            "show-download-button": "",
            "show-preview-button": "",
            onPreview: M,
            onRemove: P,
            onDownload: A,
            "file-list-style": { display: "flex", flexWrap: "wrap" }
          }, null, 8, ["default-file-list", "max"])
        ])
      ])
    ], 64));
  }
});
export {
  se as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/file-upload/fileUpload.vue.js
// module id = 822
// module chunks = 41